
import { MutationsService } from '@vedicium/object-mutations';
import { ValidatorUtil } from '@vedicium/vue-core';
import Vue, { PropType } from 'vue';
import { APP_ERROR_EVENT } from '../../../../../constants';
import { Core } from '../../../../../services/core';

import { OptionPartEntity, OptionPartsStore } from '../../../../../services/parts';
import { PartsOptionsCompatibilityForm } from '../components';

export default Vue.extend({
  name: 'partsOptionsViewCompatibility',
  props: {
    option: {
      type: Object as PropType<OptionPartEntity>,
    },
  },
  data() {
    return {
      isLoadingForm: false,

      metadata: {
        option: JSON.parse(JSON.stringify(this.option)) as OptionPartEntity,
      },
    };
  },
  components: {
    PartsOptionsCompatibilityForm,
  },

  methods: {
    async validate() {
      await ValidatorUtil.validateArray([(this.$refs.compatibility as Vue).$v]);
    },
    async onSubmit() {
      this.$set(this, 'isLoadingForm', true);
      try {
        await this.validate();

        const mutations = MutationsService.getMutationsByComparison(
          this.option,
          this.metadata.option,
          ['models'],
        );

        if (mutations.length > 0) {
          const entity = await OptionPartsStore.update(this.option._meta.guid, mutations);

          this.$emit('update:option', entity);
          this.$set(this.metadata, 'option', JSON.parse(JSON.stringify(entity)));
        }

        this.$bvToast.toast('Document successfully updated', {
          title: 'Update successful',
          variant: 'success',
          solid: true,
        });
      } catch (e) {
        Core.Eventhub.emit(APP_ERROR_EVENT, e);
        console.error(e);
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
});
